import workDetailsSchema from '@Entities/schemas/work/work-details-schema'
import { z } from 'zod'
import alternativeTitleSchema from '@Entities/schemas/work/alternative-title-schema'
import originalPublisherSchema from '@Entities/schemas/work/publisher-schema'
import writerSchema from '@Entities/schemas/work/writer-schema'
import recordingSchema from '@Entities/schemas/work/recording-schema'
import { numericMessage, stringMessage, stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'

import { WriterModel } from '@Entities/work/writer-model'

const workSchema = workDetailsSchema.extend({
    lastErrorMessage: z.any().optional().nullable(),
    topPublisherIpId: z
        .number({ error: numericMessage('Top publisher ID') })
        .optional()
        .nullable(),
    masterTransactionId: z
        .number({ error: numericMessage('Master transaction ID') })
        .optional()
        .nullable(),
    id: z
        .number({ error: numericMessage('ID') })
        .optional()
        .nullable(),
    alternativeTitles: z.array(alternativeTitleSchema),
    originalPublishers: z.array(originalPublisherSchema).min(1, 'Work must have at least 1 publisher'),
    writers: z
        .array(writerSchema)
        .min(1, 'Work must have at least 1 writer')
        .refine((writers) => writers.some((writer: WriterModel) => writer.roleCode === 10 || writer.roleCode === 11), {
            message: 'At least one Composer/Author or Composer writer role is required to submit a work registration.',
            path: [0, 'roleCode'],
        }),
    recordings: z.array(recordingSchema),
    isComplete: z.boolean(),
    errors: z.any().optional(),
    updateDate: z.string({ error: stringMessage('Update date') }).nullable(),
    totalKnownShares: z.number({ error: numericMessage('Total known shares') }).nullable(),
    registrationHistoryStatus: z
        .string({ error: stringMessage('Registration history status') })
        .max(20, stringSizeMaxMessage('Registration history status', 20))
        .nullable(),
    registrationHistoryIndicator: z
        .string({ error: stringMessage('Registration history indicator') })
        .max(20, stringSizeMaxMessage('Registration history indicator', 20))
        .nullable(),
    parent: z
        .number({ error: numericMessage('Parent') })
        .nullable()
        .optional(),
    registrationHistoryDate: z.string({ error: stringMessage('Registration history date') }).nullable(), // ISO8601
    submissionDate: z
        .string({ error: stringMessage('Submission date') })
        .nullable()
        .optional(), // ISO8601
    submissionId: z
        .number({ error: numericMessage('Submission ID') })
        .nullable()
        .optional(),
    songCode: z
        .string({ error: stringMessage('Song code') })
        .optional()
        .nullable(),
    referenceId: z
        .string({ error: stringMessage('Reference ID') })
        .optional()
        .nullable(),
    sourceId: z
        .number({ error: numericMessage('Source ID') })
        .optional()
        .nullable(),
    propertyId: z
        .union([z.string({ error: stringMessage('Property ID') }), z.number({ error: stringMessage('Property ID') })])
        .nullable(),
    preTerminationEndDate: z
        .string({ error: stringMessage('Pre-Termination end date') })
        .optional()
        .nullable(),
    localId: z
        .string({ error: stringMessage('Local ID') })
        .optional()
        .nullable(),
    publicDomainFlag: z.string({ error: stringMessage('Public domain flag') }).optional(),
})

export default workSchema
